import React from "react";
import { useDispatch } from "react-redux";
import { MainModal } from "../../../../components/modal/MainModal";
import { deleteOrganization } from "../redux/organizationsSagas";

export const Delete = ({ isOpen, onClose, selected: { id, name } = {} }) => {
  const dispatch = useDispatch();

  const primaryBtnHandler = () => {
    dispatch(deleteOrganization({ id }));
    onClose();
  };

  return (
    <MainModal
      parentSelector=".admin-organizations"
      isOpen={isOpen}
      onClose={onClose}
      headerText="Delete"
      headerCloseHandler={onClose}
      width={300}
      height="auto"
      primaryButtonText="Delete"
      primaryBtnHandler={primaryBtnHandler}
      primaryButtonClass="critical"
      secondaryBtnText="Cancel"
      secondaryBtnHandler={onClose}
      secondaryBtnClass="secondary"
      containerClassName="dialog"
      isAdminPanel={false}
    >
      Are you sure to delete <span className="text-bold">{name}</span> organization?
    </MainModal>
  );
};
